import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-t-open-question',
  templateUrl: './t-open-question.component.html',
  styleUrls: ['./t-open-question.component.css']
})
export class TOpenQuestionComponent extends GeneralTeacherComponent {

  question: string = "";
  showCode: string="";
  code: string = "";
  useTable: boolean = false;

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected selfcorrectingService: SelfcorrectingService) {
    super(topicService, activatedRoute);
  }

  ngOnInit() {
    super.ngOnInit();
    this.type = "openQuestion";
    this.title = this.get("openQuestion");
  }

  reset() {
    super.reset();
    this.title = this.get("openQuestion");
    this.question = "";
    this.code = "";
    this.showCode = "";
    this.useTable = false;
  }

  generateDefinition(): any {
    let definition: any = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.level = 2;
    definition.image = "./assets/images/openQuestion_white.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    definition.typespecifics = {};
    definition.typespecifics.question = this.question;
    definition.typespecifics.code = this.code;
    if(this.question=='twoErrorsEAN' || this.question=='twoErrorsISBN'){
      definition.typespecifics.useTable = this.useTable;
    }
    definition.level = this.question == "checkBitEAN" || this.question == "twoErrorsEAN" ? 2 : 3
    definition.key = "dataRepresentation%openQuestion%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    let questionS = "";
    let typeSpecS = "";
    if (this.question != undefined && this.question != "") {
      questionS = this.question;
      typeSpecS = this.code;
    } else {
      questionS = this.description;
    }
    definition.key = definition.key.concat(questionS, "%", typeSpecS, "%", this.description);
    this.id = definition.id;
    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.question = this.configuration.typespecifics.question;
    this.code = this.configuration.typespecifics.code;
    this.normalizeCode();
  }

  /** normalizes the codes and computes the control bits */
  normalizeCode() {
    this.code = this.code.replace(/[^0-9]/gi, "");
    if ((this.question == "checkBitEAN" || this.question == "twoErrorsEAN")) {
      this.code = this.code.substr(0, 12);
      this.showCode = this.code;
      if (this.code.length == 12) {
        this.showCode = this.code.concat(this.selfcorrectingService.eanCheckBit(this.code));
      }
    } else {
      let result = "";
      this.code=this.code.substr(0,9);
      this.showCode = this.code;
      if (this.code.length > 0) {
        result = this.code.substr(0, 1).concat("-");
      }
      if (this.code.length > 1) {
        result = result.concat(this.code.substr(1, 3));
      }
      if (this.code.length > 3) {
        result = result.concat("-", this.code.substr(4, 5));
      }
      if (this.code.length >= 9) {
        result = result.concat("-");
        result = result.concat(this.selfcorrectingService.isbnCheckBit(this.code));
      }
      this.showCode = result;
    }
  }

  
}
